export const BookingProviders = [
  {
    numericValue: 0,
    textValue: 'STAYIN',
  },
  {
    numericValue: 1,
    textValue: 'HOMEAWAY_DEPRECATED',
  },
  {
    numericValue: 2,
    textValue: 'HOMEAWAY',
  },
  {
    numericValue: 3,
    textValue: 'FEWOSCOUT',
  },
  {
    numericValue: 4,
    textValue: 'FERIENHAUSMIETE',
  },
  {
    numericValue: 5,
    textValue: 'TRAUM_FERIENWOHNUNGEN',
  },
  {
    numericValue: 6,
    textValue: 'OSTSEEKLAR',
  },
  {
    numericValue: 7,
    textValue: 'FERIENWOHNUNGEN',
  },
  {
    numericValue: 8,
    textValue: 'KOMM_ZUR_SEE',
  },
  {
    numericValue: 9,
    textValue: 'OSTSEE_FERIENWOHNUNGEN',
  },
  {
    numericValue: 10,
    textValue: 'BELLMUNDO',
  },
  {
    numericValue: 11,
    textValue: 'TOMAS',
  },
  {
    numericValue: 12,
    textValue: 'SECRA',
  },
  {
    numericValue: 13,
    textValue: 'MEIN_MONTEURZIMMER',
  }
]
